import $ from 'jquery';
import { debounce } from '../utils/functions';

const $window = $(window);
const loadDelay = 500;
const LOADING_CLASS = 'client-slider--loading';

const carousel = (el, index) => {
    const data = {
        cardWidth: 0,
        el: el,
        sliderOuter: el.find('.client-slider__outer'),
        slider: el.find('.client-slider__inner'),
        cards: el.find('.client-slider__card'),
        transition: el.find('.client-slider__inner').css('transition'),
    };

    $window.off(`resize:width.client-slider${index}`);

    if (data.cards.length) {
        setTimeout(() => init(data), loadDelay);

        $window.on(
            `resize:width.client-slider${index}`,
            debounce(() => data.el.addClass(LOADING_CLASS), true, loadDelay)
        );
        $window.on(
            `resize:width.client-slider${index}`,
            debounce(() => init(data), false, loadDelay)
        );

        setInterval(() => {
            slide(data);
            setTimeout(() => {
                afterSlide(data);
            }, 500);
        }, 3000);
    }
};

const init = data => {
    data.cards.removeAttr('style');
    let width;
    if (data.sliderOuter.width() >= 600) {
        width = data.sliderOuter.width() / 6;
    } else if (data.sliderOuter.width() >= 480 && data.sliderOuter.width() < 600) {
        width = data.sliderOuter.width() / 5;
    } else {
        width = data.sliderOuter.width() / 3;
    }

    data.cards.css({
        'min-width': width,
        'max-width': width,
    });
    data.cardWidth = data.cards.outerWidth(true);

    data.el.removeClass(LOADING_CLASS);
};

const slide = data => {
    data.slider.css('transition', data.transition);
    data.slider.css('transform', `translate(-${data.cardWidth}px)`);
};

const afterSlide = data => {
    const firstChild = data.slider.children().first();
    if (firstChild.length) {
        data.slider.append(firstChild);
        data.slider.css({
            transition: 'none',
            transform: 'translate(0)',
        });
        // setTimeout(() => data.slider.css('transition', data.transition));
    }
};

export const reloadScriptClientSlider = () => {
    const el = $('.client-slider');
    el.addClass(LOADING_CLASS);

    el.each(function (index) {
        carousel($(this), index);
    });
};
reloadScriptClientSlider();
